// extracted by mini-css-extract-plugin
export default {"base":"spinner_base__2crg7","spinner":"spinner_spinner__6LOe0"};